import React from 'react';
import { Redirect, Route } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import Dashboard from './components/Dashboard';
import Login from './components/Login';

export default (
  <Router>
    <div>
      <Route path='/' component={App} />
      <Route path='/login' component={Login} />
      <Route path='/dashboard' component={Dashboard} />
      <Route path='/redirect' component={Dashboard} />
    </div>
  </Router>
);



// WEBPACK FOOTER //
// ./src/router.js